module.exports = __webpack_public_path__ + "img/selvan-pandaram.96abc110.png";